export enum BindingPhase
{
    New = 'new',
    NewExtend = 'newExtend',

    Edit = 'edit',
    EditExtend = 'editExtend',
}
